import axios from "axios";

const pickFirst = (...values) => {
  for (const value of values) {
    if (value === undefined || value === null) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return "";
};

const asObject = (value) =>
  value && typeof value === "object" && !Array.isArray(value) ? value : {};

/**
 * GET https://fundswalla.in/loan_backend/profileCustomer.php
 * PHP session cookie required (set by loginCustomerMobile.php).
 * GET only — POST returns 405.
 */
export const parseProfileCustomerResponse = (raw) => {
  const body = raw && typeof raw === "object" ? raw : {};
  const data = asObject(body.data);
  const nested = asObject(data.profile || data.customer || data.user || data.session_data);
  const source = { ...nested, ...data };

  const mobile = String(
    pickFirst(
      source.customer_mobile,
      source.mobile,
      source.phone,
      source.mobile_no,
      nested.customer_mobile
    )
  )
    .replace(/\D/g, "")
    .slice(-10);

  const name = pickFirst(
    source.name,
    source.customer_name,
    source.full_name,
    source.fullName,
    [source.first_name || source.firstName, source.middle_name, source.last_name || source.lastName]
      .filter(Boolean)
      .join(" ")
  );

  const email = pickFirst(source.email, source.email_id, source.email_personal);
  const avatarUrl = pickFirst(
    source.photo,
    source.avatar,
    source.profile_photo,
    source.selfie,
    source.image
  );
  const message = pickFirst(body.message, body.Message, source.message);

  const ok =
    body.status === true ||
    body.status === 1 ||
    body.success === true ||
    Boolean(name || email || mobile);

  return {
    ok: Boolean(ok && (name || email || mobile)),
    message,
    name,
    email,
    mobile,
    avatarUrl,
    raw: source,
  };
};

export const fetchCustomerProfile = async (url, customerMobile) => {
  const mobile = String(customerMobile || "")
    .replace(/\D/g, "")
    .slice(-10);
  if (mobile.length !== 10) {
    return { ok: false, message: "Invalid mobile", name: "", email: "", mobile: "", avatarUrl: "", raw: {} };
  }

  const resp = await axios.get(url, {
    params: { customer_mobile: mobile },
    timeout: 20000,
    withCredentials: true,
    validateStatus: () => true,
  });

  let body = resp.data;
  if (typeof body === "string") {
    try {
      body = JSON.parse(body);
    } catch {
      body = { status: false, message: body };
    }
  }

  const parsed = parseProfileCustomerResponse(body);
  if (parsed.ok) return parsed;

  return {
    ...parsed,
    message:
      parsed.message ||
      (resp.status === 401
        ? "Customer session not found."
        : "Unable to load profile."),
  };
};
